var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-signup-details pb24 bc-cCF5" }, [
    _c("div", { staticClass: "flex space-between w1200 mt24 align-left" }, [
      _c("div", { staticClass: "w100p bc-cCFF" }, [
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            { staticClass: "mt32 ml32 mb32" },
            [
              _c("yxtf-image", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.data && _vm.data.coverUrl,
                    expression: "data && data.coverUrl",
                  },
                ],
                staticClass: "d-img rtl4 rtr4 rbl4 rbr4",
                attrs: { src: _vm.data.coverUrl, fit: "cover" },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "mt32 ml24 mr32 mb32 flex-value-1" }, [
            _c(
              "div",
              {
                staticClass:
                  "mb12 fw500 fs24 ellipsis lineClamp2 word-break pt1 pb1",
              },
              [
                _c(
                  "yxtf-tag",
                  {
                    staticClass: "pl7 pr7 fs14 relative top-1",
                    attrs: { coverType: "blue", size: "small", type: "info" },
                  },
                  [_vm._v(_vm._s(_vm.data.appName))]
                ),
                _c("span", { attrs: { title: _vm.data.projectName } }, [
                  _vm._v(_vm._s(_vm.data.projectName)),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mb12 h48 bc-cCFA rtl4 rtr4 rbl4 rbr4 pl10" },
              [
                _vm.data.pointPrice
                  ? [
                      _c("img", {
                        staticClass: "d-integral relative top-5",
                        attrs: {
                          src:
                            _vm.staticBaseUrl +
                            "assets/141df7bc/85e5b524/a27406.svg",
                          alt: "",
                        },
                      }),
                      _c("span", { staticClass: "ml4 c-cC26 fs24 fw500" }, [
                        _vm._v(_vm._s(_vm.data.pointPrice)),
                      ]),
                      _c("span", { staticClass: "ml4 c-cC75 relative top-3" }, [
                        _vm._v(_vm._s(_vm.language().msg_integral)),
                      ]),
                      _vm.points.totalMallPoint
                        ? _c(
                            "span",
                            { staticClass: "ml62 c-cC75 relative top-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.language().lbl_available_points) +
                                  "："
                              ),
                              _c("span", { staticClass: "c-cC26" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.points.totalMallPoint.toLocaleString()
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _c("span", { staticClass: "c-cC59 fs20 fw500 ml2" }, [
                        _vm._v(_vm._s(_vm.language().msg_free)),
                      ]),
                    ],
                _vm.timeCountDownValue && _vm.data.projectStatus === 2
                  ? _c(
                      "span",
                      { staticClass: "pull-right c-cC59 mr16" },
                      [
                        _c("yxtf-svg", {
                          staticClass: "d-time relative top3 mr4",
                          attrs: {
                            width: "16px",
                            height: "16px",
                            "icon-class": "history",
                          },
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.language().lbl_count_down) +
                              "：" +
                              _vm._s(_vm.timeCountDownText)
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "mb16 rtl4 rtr4 rbl4 rbr4 pl10" },
              _vm._l(_vm.infos, function (info, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "w416 inline-block vertical-align-top",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mb8 c-cC8C relative" },
                      [
                        _c(
                          "yxt-tooltip",
                          {
                            staticClass:
                              "absolute top0 inline-block w58 justify ellipsis",
                            attrs: {
                              effect: "dark",
                              content: info.label,
                              placement: "top",
                              "open-filter": true,
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(info.label))])]
                        ),
                        _c("span", { staticClass: "absolute top0 left58" }, [
                          _vm._v("："),
                        ]),
                        info.type === "percentage"
                          ? _c(
                              "span",
                              { staticClass: "c-cC26 block pl70" },
                              [
                                _c(
                                  "yxtf-progress",
                                  {
                                    staticClass: "relative top-1",
                                    attrs: { percentage: info.value },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "c-cC26",
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(info.value) +
                                            "%（" +
                                            _vm._s(
                                              info.value === 100
                                                ? _vm.language().msg_full
                                                : info.desc
                                            ) +
                                            "）"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "c-cC26 block pl70 ellipsis lineClamp2 word-break lh22",
                              },
                              [
                                _c(
                                  "yxtf-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      effect: "dark",
                                      "open-filter": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ellipsis" },
                                      [
                                        _c("yxtbiz-user-name", {
                                          attrs: {
                                            name: info.value || "--",
                                            split: "、",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("yxtbiz-user-name", {
                                      attrs: {
                                        slot: "content",
                                        name: info.value || "--",
                                        split: "、",
                                      },
                                      slot: "content",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "rtl4 rtr4 rbl4 rbr4 pl10" },
              [
                _vm._l(_vm.opts, function (opt, index) {
                  return [
                    opt.key !== "my" &&
                    opt.key !== "all" &&
                    (_vm.ruleResultUsers.length > 0 ||
                      (_vm.extraConditionArr &&
                        _vm.extraConditionArr.length > 0))
                      ? _c(
                          "yxt-popover",
                          {
                            key: index,
                            staticClass: "mr16",
                            attrs: {
                              placement: "bottom",
                              "max-width": "560",
                              "max-height": "300",
                              trigger: "hover",
                              "visible-arrow": true,
                            },
                          },
                          [
                            _c(
                              "yxtf-button",
                              {
                                class: opt.class,
                                attrs: {
                                  slot: "reference",
                                  size: "larger2",
                                  type: opt.class ? "" : "primary",
                                  plain: !!opt.class,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.goOpt(opt)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(opt.label))]
                            ),
                            _c("div", { staticClass: "yxtbiz-signup" }, [
                              _c(
                                "div",
                                { staticClass: "mah276" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-cC26 fs16 mb4 fw500" },
                                    [_vm._v(_vm._s(_vm.language().tit_non))]
                                  ),
                                  _c("div", { staticClass: "c-cC75 fs14" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.data.requireCount === 1
                                          ? _vm.language().lbl_check_con1
                                          : _vm.language().lbl_check_con0
                                      )
                                    ),
                                  ]),
                                  _vm.ruleResultUsers.length > 0
                                    ? _vm._l(
                                        _vm.ruleResultUsers[0].rules,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              class:
                                                "fs14 c-cC26 " +
                                                (index === 0 ? "mt16" : "mt24"),
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "dot bc-cCD8 relative top-1",
                                              }),
                                              item.ruleCode === "cers"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName) +
                                                        "（" +
                                                        _vm._s(
                                                          item.requireCount ===
                                                            0
                                                            ? _vm.language()
                                                                .lbl_check_concer00
                                                            : _vm.language()
                                                                .lbl_check_concer1
                                                        ) +
                                                        "）"
                                                    ),
                                                  ])
                                                : item.ruleCode === "exams"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName) +
                                                        "（" +
                                                        _vm._s(
                                                          item.requireCount ===
                                                            0
                                                            ? _vm.language()
                                                                .lbl_check_conexam00
                                                            : _vm.language()
                                                                .lbl_check_conexam1
                                                        ) +
                                                        "）"
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName)
                                                    ),
                                                  ]),
                                              _c("br"),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-cC75 fs14 ml16 inline-block",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.ruleValueInfo)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                  _vm.extraConditionArr &&
                                  _vm.extraConditionArr.length > 0
                                    ? _vm._l(
                                        _vm.extraConditionArr,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              class:
                                                "fs14 c-cC26 " +
                                                (index === 0 &&
                                                !_vm.ruleResultUsers &&
                                                !_vm.ruleResultUsers[0] &&
                                                !_vm.ruleResultUsers[0].rules
                                                  ? "mt16"
                                                  : "mt24"),
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "dot bc-cCD8 relative top-1",
                                              }),
                                              item.ruleCode === "cers"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName) +
                                                        "（" +
                                                        _vm._s(
                                                          item.requireCount ===
                                                            0
                                                            ? _vm.language()
                                                                .lbl_check_concer00
                                                            : _vm.language()
                                                                .lbl_check_concer1
                                                        ) +
                                                        "）"
                                                    ),
                                                  ])
                                                : item.ruleCode === "exams"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName) +
                                                        "（" +
                                                        _vm._s(
                                                          item.requireCount ===
                                                            0
                                                            ? _vm.language()
                                                                .lbl_check_conexam00
                                                            : _vm.language()
                                                                .lbl_check_conexam1
                                                        ) +
                                                        "）"
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ruleName)
                                                    ),
                                                  ]),
                                              _c("br"),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "c-cC75 fs14 ml16 inline-block",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.ruleValueInfo)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ],
                          1
                        )
                      : _c(
                          "yxtf-tooltip",
                          {
                            key: index,
                            attrs: {
                              placement: "top",
                              content: opt.title,
                              disabled: !opt.title,
                            },
                          },
                          [
                            _c(
                              "yxtf-button",
                              {
                                class: opt.class,
                                attrs: {
                                  size: "larger2",
                                  type: opt.class ? "" : "primary",
                                  plain: !!opt.class,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.goOpt(opt)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(opt.label))]
                            ),
                          ],
                          1
                        ),
                  ]
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "clearfix space-between w1200 mt24 align-left" }, [
      _c(
        "div",
        { staticClass: "w100p-312-24 bc-cCFF pull-left" },
        [
          _c(
            "yxtf-tabs",
            {
              model: {
                value: _vm.tabActive,
                callback: function ($$v) {
                  _vm.tabActive = $$v
                },
                expression: "tabActive",
              },
            },
            _vm._l(
              _vm.tabs.filter(function (_) {
                return _.value === "2"
                  ? (_vm.rules.datas || []).length > 0 || _vm.showConditionTab
                  : true
              }),
              function (tab, index) {
                return _c(
                  "yxtf-tab-pane",
                  { key: index, attrs: { label: tab.label, name: tab.value } },
                  [
                    _c(
                      "div",
                      { staticClass: "mt24 hm-509" },
                      [
                        _vm.tabActive === "2"
                          ? [
                              _c(
                                "div",
                                { staticClass: "ml32 mb24 c-cC75 fs14" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().msg_rule) +
                                      _vm._s(
                                        _vm.data.requireCount === 1
                                          ? _vm.language().lbl_check_con1
                                          : _vm.language().lbl_check_con0
                                      )
                                  ),
                                ]
                              ),
                              _vm._l(_vm.rules.datas, function (rule, index) {
                                return _c(
                                  "div",
                                  { key: index, class: "mb32 ml32 mr32" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-cC26 fs16 mb8 fw500" },
                                      [_vm._v(_vm._s(rule.ruleName))]
                                    ),
                                    rule.ruleCode === "cers"
                                      ? _c(
                                          "div",
                                          { staticClass: "c-cC8C mb8 fs14" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                rule.requireCount === 0
                                                  ? _vm.language()
                                                      .lbl_check_concer00
                                                  : _vm.language()
                                                      .lbl_check_concer1
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    rule.ruleCode === "exams"
                                      ? _c(
                                          "div",
                                          { staticClass: "c-cC8C mb8 fs14" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                rule.requireCount === 0
                                                  ? _vm.language()
                                                      .lbl_check_conexam00
                                                  : _vm.language()
                                                      .lbl_check_conexam1
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "c-cC75 fs14 word-break-all",
                                      },
                                      [_vm._v(_vm._s(rule.ruleValueInfo))]
                                    ),
                                  ]
                                )
                              }),
                              _vm._t("condition"),
                            ]
                          : _vm.tabActive === "1"
                          ? _vm._t("content")
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              }
            ),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "w312 bc-cCFF pull-right" }, [
        _c("div", { staticClass: "mt24 ml24 mr24 fs18 fw500" }, [
          _vm._v(_vm._s(_vm.language().tit_calendar)),
        ]),
        _c(
          "div",
          { class: _vm.dayData && _vm.dayData.length ? "" : "mb24" },
          [
            _c("signup-calendar", {
              staticClass: "hm-134",
              attrs: { value: _vm.currentDate, dotDays: _vm.dotDays },
              on: { week: _vm.getCalendar, input: _vm.queryList },
            }),
            _vm._l(_vm.dayData, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "relative ml16 mr16 h72 pl24 bc-cCF5-hover pt12 border-box rtl4 rtr4 rbl4 rbr4 pointer",
                  on: {
                    click: function ($event) {
                      return _vm.toDetail(item)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "c-cCD9 fs14 absolute left8" }, [
                    _vm._v(_vm._s((index + 1 + "").padStart(2, "0"))),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "c-cC26 fs14 ellipsis",
                      attrs: {
                        title:
                          "【" +
                          (item.appName || "") +
                          "】" +
                          (item.projectName || ""),
                      },
                    },
                    [
                      _vm._v(
                        "【" +
                          _vm._s(item.appName || "") +
                          "】" +
                          _vm._s(item.projectName || "")
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "c-cC8C fs12 mt4 pl8" }, [
                    _vm._v(
                      _vm._s(
                        _vm.timeText2(
                          item.startTime,
                          item.endTime,
                          item.projectStatus
                        )
                      )
                    ),
                  ]),
                ]
              )
            }),
            _vm.dayDataCount > 5
              ? _c(
                  "div",
                  {
                    staticClass:
                      "ml16 mr16 h46 c-cC59 fs14 align-center bt1 pointer",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("toHome")
                      },
                    },
                  },
                  [
                    _c("yxtf-button", { attrs: { type: "text" } }, [
                      _vm._v(_vm._s(_vm.language().btn_more)),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }